import { Box } from '@mui/material'
import type { ReactNode } from 'react'
import type { SiteLayoutData } from '@src/types/siteData'
import Footer from '../Footer'
import Header from '../Header/Header'

type DevicesLayoutProps = {
  children: ReactNode
  site: SiteLayoutData
}

export default function DevicesLayout({ children, site }: DevicesLayoutProps) {
  return (
    <>
      <Header navbar={site.navbar} products={site.products} />
      <Box component="main">{children}</Box>
      <Footer footer={site.footer} />
    </>
  )
}
